module.exports = __webpack_public_path__ + "fccf8c2279c48c9e15b6eb9709af88c5.jpg";